import React from 'react'

export const Loader = () => {
  return (
    <div>

        <div class="spinner"></div>
    </div>
  )
}
